var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      class: ["dialog-item", _vm.className],
      attrs: {
        visible: _vm._visible,
        title: _vm.title,
        center: "",
        top: "240px",
        width: _vm.width,
        "close-on-click-modal": false,
        "close-on-press-escape": _vm.closeEscape,
        "show-close": _vm.showClose,
      },
      on: { close: _vm.close },
    },
    [
      _vm._t("default"),
      !_vm.noButton
        ? _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.button.left
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn cancel-btn",
                      attrs: { disabled: _vm.leftDisabled },
                      on: { click: _vm.cancel },
                    },
                    [_vm._v(_vm._s(_vm.button.left))]
                  )
                : _vm._e(),
              _vm.button.right
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn comfirm-btn",
                      attrs: {
                        disabled: _vm.disabled,
                        type: "primary",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.comfirm },
                    },
                    [_vm._v(_vm._s(_vm.button.right))]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }